export default __webpack_public_path__ + "static/media/time-clock-circle.edfea757.svg";